<template>
    <b-button
        @click="() => { modalState = true }"
        size="sm"
        :disabled="disabled"
        :variant="(httpRequestInProgress) ? 'success': 'primary'"
        block
    ><!-- button -->
        <span v-if="httpRequestInProgress">
            <b-spinner
                type="grow"
                label="Loading..."
                small
            />
            </span>
        <span v-else>Zurück auf in Bearbeitung</span>
        <b-modal
            v-model="modalState"
            id="modal-unfreeze-order"
            title="Bestellung »Zurück auf in Bearbeitung«"
            @ok="submit()"
            cancel-title="abbrechen"
            size="md"
        ><!-- modal -->
            Diese Bestellung wirklich »Zurück auf in Bearbeitung« setzen?
        </b-modal>
    </b-button>  
</template>
<script>
    export default {
        props: ['customerOrder', 'orderStates']
        , data() {
            return {
                modalState: false,
                httpRequestInProgress: false
            }
        }
        , computed: {
           disabled: function() {
                return (this.orderStates.codes.WAIT !== this.customerOrder.orderState)
                    || this.httpRequestInProgress;
            }
        }
        , methods: {
            submit() {
                const payload = {
                    customerOrderId: this.customerOrder.id
                };
                this.httpRequestInProgress = true;
                Promise.all([
                    axios.post('/customerorder/action/reopen_postponed_order', payload),
                    new Promise(r => setTimeout(r, 500))
                ]).then( () => {
                    this.customerOrder.orderState = this.orderStates.codes.IN_PROGRESS;
                    this.httpRequestInProgress = false;
                }).catch( error => {
                    this.$bvToast.toast( "Konnte Status nicht ändern!", {
                        title: "Zurück auf in Bearbeitung",
                        autoHideDelay: 8000,
                        appendToast: false,
                        variant: 'danger'
                    });
                    console.error(error);
                    this.httpRequestInProgress = false;
                });
            }
        }
    }
</script>
